export default "__VITE_ASSET__D6aKygG5__"